import { createAsyncThunk } from '@reduxjs/toolkit'
import SeriesSnapshot from './series-snapshot-model'
import {
  delete_seriesSnapshot,
  load_seriesSnapshots,
  store_seriesSnapshot,
} from './seriesSnapshot-service'

export const LoadSeriesSnapshotsAsync = createAsyncThunk<any, any>(
  'composer/load/seriesSnapshot',
  async (params: { uid: string }) => {
    return await load_seriesSnapshots(params)
  },
)

export const CreateSeriesSnapshotAsync = createAsyncThunk<any, any>(
  'composer/create/seriesSnapshot',
  async (params: SeriesSnapshot) => {
    return await store_seriesSnapshot(params)
  },
)

export const DeleteSeriesSnapshotAsync = createAsyncThunk<any, any>(
  'composer/delete/seriesSnapshot',
  async (params) => {
    return await delete_seriesSnapshot(params)
  },
)
